export default function MaintenancePlansDetailsTasksController($scope, $stateParams, MaintenanceService) {

  'ngInject';

  $scope.addNewTaskButtonPressed = () => {};

  MaintenanceService
    .getTaskPlans($stateParams.maintenanceplanId)
    .then(response => {
      $scope.tasksData = response.data;
    }, error => {
      // console.log("Failed to load tasks");
      // TODO need better error handling here!
    });
}